import { Post } from '../http/httpVerbs';

export const apiPostChatGPT = async (briefing) => {
    try {
        return await Post(`${process.env.REACT_APP_API_URL}/campanhasItens/geraroteiro`, { briefing });
    } catch (error) {
        throw error;
    }
};
